import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {RsvpResponseBarPresenter} from './RsvpResponseBarPresenter';
import {PresenterProps, withPresenter} from '../../../../../Support/with_presenter';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {classNames} from '../../../../Support/classNames';

interface OwnProps {
    calendarEvent: CalendarEvent;
    className?: string;
}

const RsvpResponseBarComponent: FunctionComponent<OwnProps & PresenterProps<RsvpResponseBarPresenter>> = observer(
    ({className, presenter}) => {
        return (
            <div className={classNames('rsvp-bar', className)}>
                {presenter.ratios.yes > 0 && (
                    <div className="rsvp-bar__fill rsvp-bar__fill--yes" style={{flex: presenter.ratios.yes}} />
                )}
                {presenter.ratios.no > 0 && (
                    <div className="rsvp-bar__fill rsvp-bar__fill--no" style={{flex: presenter.ratios.no}} />
                )}
                {presenter.ratios.maybe > 0 && (
                    <div className="rsvp-bar__fill rsvp-bar__fill--maybe" style={{flex: presenter.ratios.maybe}} />
                )}
                {presenter.ratios.unknown > 0 && (
                    <div className="rsvp-bar__fill rsvp-bar__fill--unknown" style={{flex: presenter.ratios.unknown}} />
                )}
            </div>
        );
    },
);

export const RsvpResponseBar = withPresenter<RsvpResponseBarPresenter, OwnProps>(
    (props, component) =>
        new RsvpResponseBarPresenter(props.calendarEvent.scheduledEventId, props.calendarEvent.startAt, component.rsvp),
    RsvpResponseBarComponent,
);
